export enum TrackerTab {
  MAP_VIEW = 'mapView',
  TABLE_VIEW = 'tableView',
  PLANOGRAM_VIEW = 'planogramView',
  THREED_PLANOGRAM_VIEW = '3DplanogramView',
  FLOOR_PLAN = 'floorPlan',
  TREE_VIEW = 'treeView'
}

export type TrackerTabType = keyof typeof TrackerTab;

export interface TrackerTabStateModel {
  entityId?: string;
  siteId: string;
  zoneId: string;
  tab: TrackerTabType;
  selectedState?: string;
  selectedCategory ?: string;
  dateRange?: { startDate: string, endDate: string},
  widgetRangeSelected ?: string;
}
